//时间戳转换为指定格式时间
const timeFormat = (value, format) => {
    let date = new Date(value*1000);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let result = "";
    if (format == undefined) {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
            h < 10 ? "0" + h : h
        }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
    if (format == "yyyy-mm-dd:hh:mm") {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}   ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
    }
    if (format == "yyyy-mm-dd") {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    }
    if (format == "yyyy年mm月dd") {
        result = `${y}年${m < 10 ? "0" + m : m}月${d < 10 ? "0" + d : d}日`;
    }
    if (format == "yyyy-mm") {
        result = `${y}-${m < 10 ? "0" + m : m}`;
    }
    if (format == "mm-dd") {
        result = ` ${m < 10 ? "0" + m : m}:${d < 10 ? "0" + d : d}`;
    }
    if (format == "hh:mm") {
        result = ` ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
    }
    return result;
};

//历史成绩
const level = (score,totalscore) => {
    console.log(score,totalscore)
    let  type=(score/totalscore)*100
    console.log(type,"成绩")
    if(type<60){
        return '不合格'
    }
    if(type>=60 && type<=70){
        return '及格'
    }
    if(type>=70 && type<=90){
        return '良好'
    }
    if(type>=90){
        return '优秀'
    }
}


//保留最后两位小数点
const decimal = (time) => {
    console.log(time,"decimal")
    if(time=='undefined'){
        return 0
    }
    else {
        let value = parseFloat(time).toFixed(2)
        return value
    }

}

//转换身份证****
const starIdentity = phoneNum => {
    let str =  String(phoneNum),
        strLen = str.slice(-12,-6);
    return str.replace(strLen,"****");
};

//给运费加0.00
const priceFilter = (price) => {
    if (price % 1 === 0) {
        return price + '.00'
    } else {
        return price
    }
}
export default {
    timeFormat,
    level,
    decimal,
    priceFilter,
    starIdentity
};